"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("../index.scss");
const OriginalPublisherCardAddWriters_1 = __importDefault(require("@Components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardAddWriters"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const pluralize_1 = __importDefault(require("pluralize"));
const WizardStepHeading_1 = __importDefault(require("@Components/WizardFlow/WizardStepHeading"));
const PublishersRelationsStep = () => {
    const { workStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const workDraftFromLocal = workStore.workDraftLocal;
    const currentRhId = rightsholderStore.currentRightsholderId;
    if (!workDraftFromLocal) {
        return null;
    }
    const typeCreator = location.href.split('/')[7]; // HARD CODE
    const originPublishers = workDraftFromLocal.originalPublishers;
    if (!originPublishers.length) {
        if (workDraftFromLocal.id) {
            return (react_1.default.createElement(react_router_dom_1.Navigate, { to: `/rightsholder/${currentRhId}/catalog/${workDraftFromLocal.isComplete ? 'work' : 'draft'}/${workDraftFromLocal.id}/edit/publishers` }));
        }
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: `/rightsholder/${currentRhId}/create-work/manual/${typeCreator}/publishers` });
    }
    return (react_1.default.createElement("div", { className: "publishers-step relation-step" },
        react_1.default.createElement(WizardStepHeading_1.default, { heading: 'Link Writer', title: workDraftFromLocal.title }, "To link a writer to a publisher, click the Add Writer button to view all writers on the work. Then, select the writer(s) to link and click the Link writers button."),
        react_1.default.createElement("div", { className: "publishers-cards-wrapper" },
            react_1.default.createElement("div", { className: "publishers-add-area" },
                react_1.default.createElement("div", { className: "publisher-wrapper" },
                    react_1.default.createElement("div", { className: "publishers-area" },
                        react_1.default.createElement("div", { className: "main-title" },
                            react_1.default.createElement("p", { className: 'bold title' }, (0, pluralize_1.default)('Publisher', originPublishers.length)),
                            react_1.default.createElement("span", { className: "small bold blue-text" }, "Required")),
                        originPublishers.length &&
                            originPublishers.map((op) => (react_1.default.createElement("div", { className: "op-wrapper", key: op.localId },
                                react_1.default.createElement(OriginalPublisherCardAddWriters_1.default, { data: op }))))))))));
};
exports.default = (0, mobx_react_1.observer)(PublishersRelationsStep);
